import dashboardApi from '@modules/dashboard/api';
import { useQuery } from '@tanstack/react-query';

const useGetCaseDistribution = (brokerageId?: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['dashboardCaseDistribution'],
    queryFn: () => dashboardApi.getCaseDistribution(brokerageId),
    retry: 2,
    // One hour
    staleTime: 1000 * 60 * 60,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export { useGetCaseDistribution };
